import Info from "@mui/icons-material/Info";
import { Link } from "@mui/material";
import { useMemo } from "react";
import { HoverChip } from "../generic/components/hover-chip";

import type { FC } from "react";

export const TemplateImageAttribution: FC<{ attributionData: { name: string; url: string } }> = ({
  attributionData,
}) => {
  const params = useMemo(() => {
    const urlParams = new URLSearchParams();
    urlParams.set("utm_source", "ChangeEngine");
    urlParams.set("utm_medium", "referral");
    return urlParams.toString();
  }, []);

  return (
    <HoverChip
      size="small"
      sx={{ position: "absolute", bottom: 5, left: 5 }}
      defaultProps={{ icon: <Info /> }}
      hoverProps={{
        icon: <Info />,
        label: (
          <>
            Photo by{" "}
            <Link href={`${attributionData.url}?${params}`} target="_blank">
              {attributionData.name}
            </Link>{" "}
            on{" "}
            <Link href={`https://www.unsplash.com?${params}`} target="_blank">
              Unsplash
            </Link>
          </>
        ),
      }}
    />
  );
};
